import { render, staticRenderFns } from "./ShippingDocumentView.vue?vue&type=template&id=7dcedc1e&"
import script from "./ShippingDocumentView.vue?vue&type=script&lang=js&"
export * from "./ShippingDocumentView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports